import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PSPDFKit from '../pspdfkit';
import {
  authenticate,
  getDocumentArrayBuffer,
  updateModifiedDate,
  loadDCIP,
  deletePage,
  getUserInformation,
  actualInsertPage
} from '../../api/legacy';
import { authenticateLegacy } from '../../api/authentication';
import {
  loadAnnotations,
  saveAnnotations,
  loadPresets,
  savePresets
} from '../../api/annotation';
import queryString from 'query-string';
import InsertModal from './insertmodal';

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

export class LegacyViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      presets: {},
      userId: '',
      showInsertModal: false,
      uploadedFiles: [],
      totalPages: 0,
      selectedInsertIndex: 0,
      insertModalError: null
    };
    this.internalSaveAnnotations = this.internalSaveAnnotations.bind(this);
    this.internalSavePresets = this.internalSavePresets.bind(this);
    this.internalDeletePage = this.internalDeletePage.bind(this);
    this.actualDeletePage = this.actualDeletePage.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.openInsertModal = this.openInsertModal.bind(this);
    this.cancelInsertModal = this.cancelInsertModal.bind(this);
    this.submitPageInsert = this.submitPageInsert.bind(this);
    this.imageUploaded = this.imageUploaded.bind(this);
    this.handleInsertIndexChange = this.handleInsertIndexChange.bind(this);
  }

  async componentDidMount() {
    const parsed = queryString.parse(this.props.location.search);
    const client = this.props.match.params.client;
    const documentId = this.props.match.params.superid;
    const applicationSessionId = parsed.appSessionId;
    const sessionId = parsed.sessionId;
    //we are going to try and get the pdf directly and pass that to the viewer... trying to get around cors/auth issues
    //let exportPdfUrl = `https://${client}.scribonline.com/pdfexport.pdf?superid=${documentId}`;

    let annotations = null;
    let pdfContent = null;
    let tmpAnnotations = null;
    let userId = null;
    let userName = null;
    try {
      if (process.env.NODE_ENV !== 'development') {
        await authenticate(client, documentId, applicationSessionId, sessionId);

        const response = await authenticateLegacy(
          client,
          documentId,
          applicationSessionId,
          sessionId
        );
        const token = response.token;

        const dcip = await loadDCIP(
          client,
          documentId,
          applicationSessionId,
          sessionId
        );
        console.log('dcip: ' + (dcip.indexOf('<DCIPDocument>') >= 0));
        const isImageDoc = dcip.indexOf('<DCIPDocument>') >= 0;

        this.setState({ token, isImageDoc, applicationSessionId, sessionId });

        try {
          const userInfo = await getUserInformation(
            client,
            applicationSessionId,
            sessionId
          );
          userId = userInfo.id;
          userName = userInfo.name;
        } catch (error) {
          console.log(error);
        }
        tmpAnnotations = await loadAnnotations(token, client, documentId);

        const presetResponse = await loadPresets(token, sessionId, client);

        if (presetResponse !== null && presetResponse.sessionJson) {
          this.setState({ presets: presetResponse.sessionJson.presetJson });
        }
      }
      if (process.env.NODE_ENV !== 'development') {
        console.log('In production');
        pdfContent = await getDocumentArrayBuffer(
          client,
          documentId,
          applicationSessionId,
          sessionId
        );
      }
      if (process.env.NODE_ENV === 'development') {
        console.log('In dev using local pdf.');
        pdfContent = '/test/test.pdf';
      }

      if (
        tmpAnnotations !== null &&
        tmpAnnotations.instantJson &&
        tmpAnnotations.instantJson.annotationJSON
      ) {
        annotations = tmpAnnotations.instantJson.annotationJSON;
        if (annotations.pdfId) {
          annotations.pdfId = null;
        }
      }

      console.log('annotations', annotations);
      this.setState((state, props) => {
        return {
          finishedLoading: true,
          pdfContent,
          annotations,
          userId,
          userName
        };
      });
    } catch (error) {
      console.log('caught error');
      console.log(error);
      this.setState((state, props) => {
        return {
          error: true,
          errorMessage: error
        };
      });
    }
  }

  internalDeletePage(pageNum) {
    // if agreed
    this.setState({
      showDeleteModal: true,
      finishedLoading: false,
      deletePageNum: pageNum
    });
  }

  async actualDeletePage() {
    const client = this.props.match.params.client;
    const documentId = this.props.match.params.superid;
    const parsed = queryString.parse(this.props.location.search);
    const applicationSessionId = parsed.appSessionId;
    const sessionId = parsed.sessionId;
    console.log(`Going to actually delete page ${this.state.deletePageNum}`);
    await deletePage(
      client,
      documentId,
      this.state.deletePageNum,
      applicationSessionId,
      sessionId
    );
    //on success load the pdf again
    let pdfContent = null;
    if (process.env.NODE_ENV !== 'development') {
      console.log('In production');
      pdfContent = await getDocumentArrayBuffer(
        client,
        documentId,
        applicationSessionId,
        sessionId
      );
    }
    if (process.env.NODE_ENV === 'development') {
      console.log('In dev using local pdf.');
      pdfContent = '/test/test.pdf';
    }
    this.setState({
      deletePageNum: '',
      pdfContent,
      showDeleteModal: false,
      finishedLoading: true
    });
  }

  async toggleDeleteModal() {
    const client = this.props.match.params.client;
    const documentId = this.props.match.params.superid;
    const parsed = queryString.parse(this.props.location.search);
    const applicationSessionId = parsed.appSessionId;
    const sessionId = parsed.sessionId;
    let pdfContent = null;
    if (process.env.NODE_ENV !== 'development') {
      console.log('In production');
      pdfContent = await getDocumentArrayBuffer(
        client,
        documentId,
        applicationSessionId,
        sessionId
      );
    }
    if (process.env.NODE_ENV === 'development') {
      console.log('In dev using local pdf.');
      pdfContent = '/test/test.pdf';
    }
    this.setState(prevState => ({
      showDeleteModal: !prevState.showDeleteModal,
      finishedLoading: true,
      pdfContent
    }));
  }

  internalSavePresets(presetJson) {
    const client = this.props.match.params.client;
    const parsed = queryString.parse(this.props.location.search);
    const sessionId = parsed.sessionId;
    savePresets(this.state.token, sessionId, presetJson, client);
  }

  internalSaveAnnotations(instantJson, pageRotation) {
    if (!instantJson.pageRotation) {
      instantJson.pageRotation = pageRotation;
    }
    const client = this.props.match.params.client;
    const documentId = this.props.match.params.superid;
    saveAnnotations(this.state.token, client, documentId, instantJson);
    const parsed = queryString.parse(this.props.location.search);
    const applicationSessionId = parsed.appSessionId;
    const sessionId = parsed.sessionId;
    updateModifiedDate(client, documentId, applicationSessionId, sessionId);
  }

  openInsertModal(page, totalPages) {
    this.setState({
      ...this.state,
      showInsertModal: true,
      selectedInsertIndex: page,
      totalPages: totalPages,
      finishedLoading: false
    });
  }

  cancelInsertModal() {
    this.setState({
      ...this.state,
      showInsertModal: false,
      finishedLoading: true
    });
  }

  imageUploaded(files) {
    let valid = true;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      console.log('type', file.type);
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpg' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/tiff' &&
        file.type !== 'image/tif'
      ) {
        valid = false;
      }
    }
    if (valid) {
      this.setState({
        uploadedFiles: files,
        insertModalError: null
      });
    } else {
      this.setState({
        uploadedFiles: [],
        insertModalError:
          'Invalid file type, please upload an image with type of png, jpg, or tif.'
      });
    }
  }

  handleInsertIndexChange(event) {
    this.setState({
      selectedInsertIndex: event.target.value
    });
  }

  toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  async submitPageInsert() {
    const client = this.props.match.params.client;
    const documentId = this.props.match.params.superid;
    const parsed = queryString.parse(this.props.location.search);
    const applicationSessionId = parsed.appSessionId;
    const sessionId = parsed.sessionId;

    const base64urlencoded = await this.toBase64(this.state.uploadedFiles[0]);
    const name = this.state.uploadedFiles[0].name;
    const image = base64urlencoded.split(',')[1];
    const exportObject = {
      number: '' + this.state.selectedInsertIndex,
      name,
      image
    };
    await actualInsertPage(
      client,
      documentId,
      applicationSessionId,
      sessionId,
      exportObject
    );
    let pdfContent = null;
    if (process.env.NODE_ENV !== 'development') {
      console.log('In production');
      pdfContent = await getDocumentArrayBuffer(
        client,
        documentId,
        applicationSessionId,
        sessionId
      );
    }
    if (process.env.NODE_ENV === 'development') {
      console.log('In dev using local pdf.');
      pdfContent = '/test/test.pdf';
    }
    this.setState({
      showInsertModal: false,
      finishedLoading: true,
      uploadedFiles: [],
      pdfContent
    });
  }

  render() {
    let licenseKey = process.env.REACT_APP_PSPDFKIT_LICENSE;
    return (
      <div className="App">
        {this.state.error && <div>{this.state.errorMessage}</div>}
        <Modal
          fade={false}
          isOpen={this.state.showDeleteModal}
          toggle={this.toggleDeleteModal}
        >
          <ModalHeader toggle={this.toggleDeleteModal}>Delete Page</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this page? This action cannot be
            undone.
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.actualDeletePage}>
              Delete Page
            </Button>{' '}
            <Button color="secondary" onClick={this.toggleDeleteModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <InsertModal
          modal={this.state.showInsertModal}
          onCancel={this.cancelInsertModal}
          onConfirm={this.submitPageInsert}
          startPage={this.state.selectedInsertIndex}
          totalPages={this.state.totalPages}
          onPageChange={this.handleInsertIndexChange}
          onImageUpload={this.imageUploaded}
          uploadedFiles={this.state.uploadedFiles}
          error={this.state.insertModalError}
        />
        {this.state.finishedLoading && (
          <PSPDFKit
            documentId={this.props.match.params.superid}
            pdfUrl={this.state.pdfContent}
            licenseKey={licenseKey}
            baseUrl={baseUrl}
            instantJSON={this.state.annotations}
            saveAnnotations={this.internalSaveAnnotations}
            presets={this.state.presets}
            savePresets={this.internalSavePresets}
            showDelete={this.state.isImageDoc}
            deletePage={this.internalDeletePage}
            client={this.props.match.params.client}
            applicationSessionId={this.state.applicationSessionId}
            sessionId={this.state.sessionId}
            userId={this.state.userId}
            userName={this.state.userName}
            openInsertModal={this.openInsertModal}
          />
        )}
      </div>
    );
  }
}

export default LegacyViewer;
